import { render, staticRenderFns } from "./personnelSkills-list.vue?vue&type=template&id=a879d52c&scoped=true&"
import script from "./personnelSkills-list.vue?vue&type=script&lang=js&"
export * from "./personnelSkills-list.vue?vue&type=script&lang=js&"
import style0 from "./personnelSkills-list.vue?vue&type=style&index=0&id=a879d52c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a879d52c",
  null
  
)

export default component.exports